import {Component, input} from '@angular/core';
import {PolicyDocument} from './policy-document';

@Component({
  selector: 'app-policy-view',
  template: `
    <h1 class="policy-title mb-3 font-semibold leading-snug sm:mb-4">{{ document().title }}</h1>

    <p class="mb-4 text-[13px] italic leading-relaxed text-gray-600 sm:text-sm">{{ document().note }}</p>

    @for (section of document().sections; track section.title; let i = $index) {
      <section class="mb-5 sm:mb-6">
        <h2 class="mb-2 text-sm font-semibold text-gray-900 sm:text-base">{{ i + 1 }}. {{ section.title }}</h2>
        <div class="flex flex-col gap-2 text-[13px] leading-relaxed text-gray-800 sm:text-sm">
          @for (item of section.items; track item) {
            <p class="m-0 break-words">{{ item }}</p>
          }
        </div>
      </section>
    }
  `,
})
export class PolicyView {
  readonly document = input.required<PolicyDocument>();
}
